import React, { useEffect, useState } from "react";
import { Card, Empty, Spin, Table, Tag, Tooltip } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import formaDePagoService from "../../services/formaDePagoService";

const FormaDePagoList = ({ refreshTrigger }) => {
	const [formasDePago, setFormasDePago] = useState([]);
	const [loading, setLoading] = useState(true);
	const isMobile = window.innerWidth < 768;

	// Cargar formas de pago al inicio y cuando cambie el trigger
	useEffect(() => {
		loadFormasDePago();
	}, [refreshTrigger]);

	const loadFormasDePago = async () => {
		try {
			setLoading(true);
			const formaDePagoList = await formaDePagoService.getAllFormasDePago();
			setFormasDePago(formaDePagoList);
		} catch (error) {
			console.error("Error al cargar formas de pago:", error);
		} finally {
			setLoading(false);
		}
	};

	// Renderizar el estado de sincronización
	const renderSyncStatus = (lastSynced) => {
		if (lastSynced) {
			const syncDate = new Date(lastSynced).toLocaleString();
			return (
				<Tooltip title={`Última sincronización: ${syncDate}`}>
					<Tag icon={<CheckCircleOutlined />} color="success">
						Sincronizado
					</Tag>
				</Tooltip>
			);
		}
		return null;
	};

	const columns = [
		{
			title: "Código",
			dataIndex: "Code",
			key: "code",
		},
		{
			title: "Descripción",
			dataIndex: "Description",
			key: "description",
		},
		{
			title: "Tipo de Pago",
			dataIndex: "Tipo_Pago",
			key: "tipoPago",
			render: (tipoPago) => (
				<Tag color={tipoPago === "Efectivo" ? "green" : "blue"}>
					{tipoPago || "Efectivo"}
				</Tag>
			),
		},
		{
			title: "Descuento",
			dataIndex: "Dto",
			key: "dto",
			render: (dto) => (dto ? `${dto}%` : "0%"),
		},
		{
			title: "Sincronizado",
			key: "syncStatus",
			render: (_, record) => renderSyncStatus(record.lastSynced),
		},
	];

	if (loading) {
		return <Spin size="large" />;
	}

	if (formasDePago.length === 0) {
		return <Empty description="No hay formas de pago registradas aún" />;
	}

	return (
		<div className="formaDePago-list-container">
			<Card title={isMobile ? "Formas de Pago" : "Formas de Pago Registradas"}>
				<Table
					columns={columns}
					dataSource={formasDePago.map((formaPago) => ({
						...formaPago,
						key: formaPago.id,
					}))}
					pagination={{ pageSize: 10 }}
					bordered
					size="middle"
					scroll={{ x: "max-content" }}
				/>
			</Card>
		</div>
	);
};

export default FormaDePagoList;
